import { render, staticRenderFns } from "./PredictCustomFieldsManager.vue?vue&type=template&id=d22c1984&scoped=true&"
import script from "./PredictCustomFieldsManager.vue?vue&type=script&lang=js&"
export * from "./PredictCustomFieldsManager.vue?vue&type=script&lang=js&"
import style0 from "./PredictCustomFieldsManager.vue?vue&type=style&index=0&id=d22c1984&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d22c1984",
  null
  
)

export default component.exports